import accordion from './modules/accordion'
import formValidation from './modules/form-validation'
import setModal from './modules/modal'

accordion()
formValidation()
setModal()